import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import styles from "../styles/Gradients.module.css";

const testGradients = [
  { name: "Floret Gradient (Hero)", className: styles.floret },
  { name: "Sunshine Gradient (Secondary)", className: styles.sunshine },
  { name: "Hull Gradient (Secondary)", className: styles.hull },
];

export default function AdminGradientTest() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "1rem",
        padding: "1rem",
      }}
    >
      {testGradients.map((g) => (
        <Card
          key={g.name}
          className={g.className}
          sx={{
            borderRadius: "15px",
            boxShadow: "none",
            height: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              sx={{ color: "#fff", textAlign: "center" }}
            >
              {g.name}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
